import { ChevronDown } from '@outdoor-voices/ui';
import PropTypes from 'prop-types';
import React from 'react';
import css from './FAQList.module.scss';
import toggleClass from '../../utils/dom/toggleClass';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var toggle = function toggle(id) {
  var targ = document.getElementById(id);
  toggleClass(targ, css.on);
};

var FAQList = function FAQList(_ref) {
  var faqs = _ref.faqs;
  return /*#__PURE__*/_jsx("ul", {
    className: css.list,
    children: faqs && faqs.edges.map(function (_ref2) {
      var faq = _ref2.node;
      var id = faq.slug ? faq.slug : faq.id;
      return /*#__PURE__*/_jsxs("li", {
        className: css.listItem,
        id: id,
        children: [/*#__PURE__*/_jsx("h3", {
          className: css.title,
          dangerouslySetInnerHTML: {
            __html: faq.title
          }
        }), /*#__PURE__*/_jsxs("button", {
          className: css.button,
          onClick: function onClick() {
            toggle(id);
          },
          type: "button",
          children: [/*#__PURE__*/_jsx("div", {
            className: css.icon,
            children: /*#__PURE__*/_jsx(ChevronDown, {})
          }), /*#__PURE__*/_jsx("span", {
            dangerouslySetInnerHTML: {
              __html: faq.title
            }
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: css.copy,
          dangerouslySetInnerHTML: {
            __html: faq.description.split('\n').join('<br>')
          }
        })]
      }, id);
    })
  });
};

FAQList.propTypes = {
  faqs: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape({
      node: PropTypes.shape({
        faqs: PropTypes.arrayOf(PropTypes.shape({
          description: PropTypes.string,
          title: PropTypes.string
        }))
      })
    }))
  }).isRequired
};
export default FAQList;